module.exports = __webpack_public_path__ + "img/pic_testNeedsKnow.b5eb7a9b.png";